module.exports = __webpack_public_path__ + "media/images/quiz_bank_header-4beee1f27e97888f15ee41c0e1bcf7f9.png";